"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _default = (0, _immutable.Record)({
  name: '',
  type: '',
  title: '',
  body: '',
  createdAt: null,
  createdBy: null,
  deletedAt: null,
  deletedBy: null,
  compositionId: null,
  publicationStage: '',
  submissionPreferences: null,
  id: null,
  updatedAt: null,
  updatedBy: null,
  portalId: null,
  usageDetails: null
}, 'PlaybookRecord');

exports.default = _default;
module.exports = exports.default;